import { post } from "../../../utils/api_utils";

export const postAddToWishlist = (programmeId, appToken) =>
  post("/api/me/wishlist/add", { programmeId }, { authToken: appToken });
export const postRemoveFromWishlist = (programmeId, appToken) =>
  post("/api/me/wishlist/remove", { programmeId }, { authToken: appToken });
